import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'

import config from '../../config'
import { checkIfLoggedIn } from '../../auth';

class AnonComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      requestToken: true,
      email: '',
      token: '',
      userId: '',
      error: '',
    }
  }

  signIn = (e) => {
    const _this = this
    e.preventDefault()
    axios.post(`${config.apiUrl}/authenticate`, this.state)
      .then(r => {
        // check if token is sent
        if (r.data.emailTokenSent) {
          _this.setState({
            requestToken: false,
            userId: r.data.user.id
          })
        }
      })
      .catch(e => {
        console.error('error: ', e)
      })
  };

  verifyToken = (e) => {
    e.preventDefault()
    axios.post(`${config.apiUrl}/verify-token`, this.state)
      .then(r => {
        if (r.data.token) {
          const myStorage = window.localStorage
          myStorage.setItem('token', `Bearer ${r.data.token}`)
          checkIfLoggedIn({dispatch: this.props.dispatch})
        } else {
          this.setState({error: 'Sorry, error signing you in. Please try again.'})
        }
      })
      .catch(e => {
        console.error('error: ', e)
      })
  };

  render() {

    const requestToken = (
      <form onSubmit={e => this.signIn(e)}>
        <div>
          <input type="email" className="mt-1" placeholder="Email" required value={this.state.email} onChange={e => {
            this.setState({email: e.target.value})
          }} />
        </div>
        <div>{this.state.error}</div>
        <button className="mt-1">Sign in</button>
      </form>
    )

    const verifyToken = (
      <form onSubmit={e => this.verifyToken(e)}>
        <div>
          <input type="text" className="mt-1" placeholder="Fyll inn kode fra epost" required value={this.state.token} onChange={e => {
            this.setState({token: e.target.value})
          }} />
        </div>
        <div>{this.state.error}</div>
        <button className="mt-1">Sign in</button>
      </form>
    )

    return (
      <div className="anon_w">
        <h2>Merkantilbygg admin</h2>
        {this.state.requestToken && requestToken}
        {!this.state.requestToken && verifyToken}
      </div>
      )
  }
}

const mapStateToProps = state => {
  return {
    //anon: state.anon,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  }
}

const Anon = connect(
  mapStateToProps,
  mapDispatchToProps
)(AnonComponent);

export default Anon


// WEBPACK FOOTER //
// ./src/components/anon/index.js